import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getEcotaxesExport = api.injectEndpoints({
  endpoints: builder => ({
    getEcotaxesExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/ecotax`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetEcotaxesExportQuery} = getEcotaxesExport;
